import React, { useState, useEffect, useRef } from "react";
import cmGif from "../img/cm-animated.avifs"; // GIF dosyasının yolu
import cmStatic from "../img/cm-static.avif";
import cmBg from "../img/cm-bg.avif";
import cmMobileGif from "../img/cm-mobile.avifs"; // Mobil cihazlar için GIF dosyasının yolu
import cmMobileStatic from "../img/cm-mobile.avif"; // Mobil cihazlar için statik görüntünün yolu
import arrow from "../img/arrow-narrow-right-svgrepo-com.svg";
import { Link as ScrollLink } from "react-scroll";
import mobileBg from "../img/mobilebg.avif";
function Cm() {
  const [isGifVisible, setGifVisible] = useState(true); // İlk olarak true yapıldı
  const [isTriggered, setIsTriggered] = useState(false); // Bileşenin bir kere tetiklenip tetiklenmediğini takip etmek için yeni bir durum
  const cmRef = useRef();
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [isBg, setIsBg] = useState(true);

  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    // İlk yüklemede GIF'i gizlemek için bir zamanlayıcı
    const initialTimer2 = setTimeout(
      () => {
        setGifVisible(false);
      },
      isMobile ? 3000 : 2100
    );

    return () => clearTimeout(initialTimer2);
  }, [isMobile]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isTriggered) {
            setGifVisible(true);
            setIsOverlayVisible(true);
            setIsTriggered(true); // Bir kere tetiklendikten sonra true yap
            setIsBg(false);
            const timerCm = setTimeout(
              () => {
                setGifVisible(false);
              },
              isMobile ? 3000 : 2100
            );
            return () => clearTimeout(timerCm);
          }
        });
      },
      { threshold: 0.5 } // %30 görünürlük sağlandığında tetikler
    );
    const currentRef = cmRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isTriggered, isMobile]);

  return (
    <div
      ref={cmRef}
      id="community-management"
      className="relative mobile:bg-pulpMobileGray w-full mobile:h-auto tablet:h-[50vh] h-screen"
    >
      <img
        src={isMobile ? mobileBg : cmBg}
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover z-30"
        style={{ display: isBg ? "block" : "none" }}
      />
      <div className="container ml-auto mr-auto">
        <img
          src={isMobile ? cmMobileGif : cmGif}
          alt="GIF"
          className={`mobile:relative absolute inset-0 tablet:object-center w-full mobile:h-[40vh] mobile:object-cover mobile:object-center tablet:object-cover h-full object-cover 2xl:object-cover ${
            isGifVisible ? "opacity-100" : "none"
          } z-20`}
          style={{ display: isGifVisible ? "block" : "none" }}
        />
        <img
          src={isMobile ? cmMobileStatic : cmStatic}
          alt="Static"
          className={`mobile:relative absolute inset-0 tablet:object-center w-full mobile:h-[40vh] mobile:object-cover mobile:object-center tablet:object-cover h-full object-cover 2xl:object-cover ${
            isGifVisible ? "none" : "opacity-100"
          } z-20`}
          style={{ display: isGifVisible ? "none" : "block" }}
        />
        <div
          className={`mobile:relative absolute mobile:w-5/6 mobile:py-0 container mobile:h-full md:ml-10 mobile:inset-0 lg:ml-10 2xl:ml-auto mr-auto ml-auto inset-0 flex flex-col items-right justify-center mobile:mt-3 mt-20 p-4 duration-1000 transform ${
            isOverlayVisible ? "opacity-100" : "opacity-0"
          } z-40`}
        >
          <div>
            <h3 className="text-orange-400 mobile:text-left mobile:text-lg tablet:text-lg text-left text-2xl xl:text-2xl 2xl:text-3xl font-semibold">
              works
            </h3>
          </div>
          <div>
            <h2 className="text-white font-semibold mobile:text-left mobile:text-3xl tablet:text-3xl lg:text-3xl xl:text-5xl hd:text-5xl 2xl:text-8xl text-left">
              Community <br />
              Management
            </h2>
          </div>
          <div className="tablet:mt-5 mobile:mt-5 mt-10 mobile:w-full w-1/3 mr-auto font-medium">
            <p className="text-white mobile:mr-auto mobile: mobile:mb-2 mobile:text-xs tablet:text-sm mobile:text-left text-left">
              We turn communities into ecosystems. <br /> Powered by real
              conversations, incentivized engagement, <br /> and precision-built
              community loops.
            </p>
          </div>
          <div className="relative mobile:mt-5 mt-10">
            <ScrollLink to="contact" smooth={true} duration={500}>
              <button className="flex mr-auto mobile:w-full mobile:bg-orange-400 tablet:text-sm tablet:p-2 rounded-full w-auto font-semibold mobile:mt-2 bg-none border-orange-400 border-solid border-2 text-white py-2 text-sm lg:text-base 2xl:text-base px-5 mobile:text-base mobile:p-2 mobile:text-center items-center mobile:justify-center justify-start">
                Schedule a Consultation
                <img
                  className="mobile:hidden"
                  src={arrow}
                  width={"45px"}
                  height={"45px"}
                  alt=""
                />
              </button>
            </ScrollLink>
          </div>
          <div className="flex mobile:scale-75 mobile:mr-auto mobile:mt-10 mobile:w-full tablet:w-1/4 w-1/3 h-24 2xl:h-28 mt-7 mr-auto mobile:justify-center justify-start">
            <div className="border-r-2 mobile:px-5 mobile:h-auto tablet:h-16 pr-5 border-orange-300">
              <h1 className="text-4xl mobile:font-bold mobile:text-left mobile:text-3xl 2xl:text-5xl tablet:text-3xl text-white">
                30+
              </h1>
              <p className="text-base mobile:text-left tablet:text-xs mobile:text-lg mt-1 text-left font-normal text-orange-300">
                Communities <br /> Builded & Activated
              </p>
            </div>
            <div className="border-r-2 mobile:px-10 mobile:h-auto tablet:h-16 h-24 2xl:h-28 px-5 text-left border-orange-300">
              <h1 className="text-4xl mobile:font-bold mobile:text-left mobile:text-3xl 2xl:text-5xl tablet:text-3xl text-white">
                24/7
              </h1>
              <p className="text-base mobile:text-left tablet:text-xs mobile:text-lg mt-1 text-left font-normal text-orange-300">
                Channel
                <br />
                Management
              </p>
            </div>
            <div className="border-orange-300 mobile:px-5 mobile:h-auto tablet:h-16 pl-5 h-24 2xl:h-28">
              <h1 className="text-4xl mobile:font-bold mobile:text-left mobile:text-3xl 2xl:text-5xl tablet:text-3xl text-white">
                90%+
              </h1>
              <p className="text-base mobile:text-left tablet:text-xs mobile:text-lg mt-1 text-left font-normal text-orange-300">
                Daily Retention <br /> on Managed Channels
              </p>
            </div>
          </div>

          <div className="hidden mobile:block mt-7 mb-12 w-full h-1 bg-pulpPurple rounded-full mx-auto"></div>
        </div>
      </div>
    </div>
  );
}

export default Cm;
